import {createContext, useContext} from 'react'
import {ErrorStore} from './ErrorStore'
import {NotificationStore} from './NotificationStore'
import {AuthStore} from './AuthStore'
import {AdvertiserStore} from './AdvertiserStore'
import {MerchantStore} from './MerchantStore'
import {ContactStore} from './ContactStore'
import {CouponStore} from './CouponStore'
import {SubscriptionStore} from './SubscriptionStore'
import {PaymentStore} from './PaymentStore'

export class Stores {
  ErrorStore: ErrorStore
  NotificationStore: NotificationStore
  AuthStore: AuthStore
  AdvertiserStore: AdvertiserStore
  MerchantStore: MerchantStore
  ContactStore: ContactStore
  CouponStore: CouponStore
  SubscriptionStore: SubscriptionStore
  PaymentStore: PaymentStore

  constructor() {
    this.ErrorStore = new ErrorStore(this)
    this.NotificationStore = new NotificationStore(this)
    this.AuthStore = new AuthStore(this)
    this.AdvertiserStore = new AdvertiserStore(this)
    this.MerchantStore = new MerchantStore(this)
    this.ContactStore = new ContactStore(this)
    this.CouponStore = new CouponStore(this)
    this.SubscriptionStore = new SubscriptionStore(this)
    this.PaymentStore = new PaymentStore(this)
  }
}

export const stores = new Stores()
const StoreContext = createContext<Stores>(stores)
export const StoreProvider = StoreContext.Provider
export const useStore = () => useContext(StoreContext)
